<div class="lms-mat-dialog-container">
    <div mat-dialog-title class="popup-mat-dialog-title">
        <h2>{{data.header}}</h2>
        <button mat-icon-button [disableRipple]="true" (click)="closeDialog(null)"
            (keydown.enter)="$event.preventDefault()">
            <div aria-label="cancel" class="lms-cancel-icon"></div>
        </button>
    </div>
    <mat-dialog-content>
        <ng-template #FormComponent></ng-template>
    </mat-dialog-content>
</div>